/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
	openFinanceSlideout,
	setActiveDrawer,
} from '../../actions/lister-actions';

const FinanceWithChevron = ({
	NewDayFinanceQuote,
	productTitle,
	MemberPrice,
	NowPrice,
	Code: productSku,
	ColourId: productId,
	financeType,
	financePromotions,
	State,
	memberPricePod,
}) => {
	const dispatch = useDispatch();

	const { AnnualMembershipFee } = useSelector((state) => state.featureSwitches);
	const { DeliveryPricingInPricePod } = useSelector(
		(state) => state.featureSwitches
	);
	
	const financeTextFactory = () => {
		if (DeliveryPricingInPricePod === true) {
			return `from ${NewDayFinanceQuote.FormattedMonthlyPriceString} monthly* `
		}
		
		return `or from ${NewDayFinanceQuote.FormattedMonthlyPriceString} monthly* `
	}

	return MemberPrice ? (
		memberPricePod ? (
			<div
				aria-label="Instalments Finance Promotion"
				className={`cursor-pointer text-link text-left leading-tight font-bold text-body-xs mt-0 z-10 relative mt-1`}
				tabIndex={0}
				role="link"
				onClick={() => {
					dispatch(
						openFinanceSlideout({
							productId,
							productSku,
							nowPrice: NowPrice,
							memberPrice: MemberPrice,
							annualMembershipFee: AnnualMembershipFee,
							financePromotionCodes: financePromotions.map(
								(p) => p.PromotionCode
							),
							isInStock: State !== 'OutOfStock',
						})
					);
				}}
				data-tag-name="member-price-monthly-installments-button"
				data-tag-finance-type="member-monthly-installments-button"
				fiveStarElligibleProduct
				data-tag-product={productTitle}
				data-testid="finance-instalments">
				{financeTextFactory()}
				<span className="ico ico-chevron-right ico-lg"></span>
			</div>
		) : (
			<div
				aria-label="Instalments Finance Promotion"
				className={`${
					DeliveryPricingInPricePod ? 'ml-0' : 'ml-3'
				} cursor-pointer text-link text-left leading-tight font-bold text-body-xs mt-0 z-10 relative mb-3`}
				tabIndex={0}
				role="link"
				onClick={() => {
					dispatch(
						openFinanceSlideout({
							productId,
							productSku,
							nowPrice: NowPrice,
							memberPrice: MemberPrice,
							annualMembershipFee: AnnualMembershipFee,
							financePromotionCodes: financePromotions.map(
								(p) => p.PromotionCode
							),
							isInStock: State !== 'OutOfStock',
						})
					);
				}}
				data-tag-name="non-member-display-monthly-installments-button"
				data-tag-finance-type={`${financeType}`}
				data-tag-product={productTitle}
				data-testid="non-member-lister-finance-instalments">
				{financeTextFactory()}
				<span className="ico ico-chevron-right ico-lg"></span>
			</div>
		)
	) : (
		<div
			aria-label="Instalments Finance Promotion"
			className={`cursor-pointer text-link text-left leading-tight font-bold text-body-xs mt-0 z-10 relative mb-3 mt-1`}
			tabIndex={0}
			role="link"
			onClick={() => {
				dispatch(
					openFinanceSlideout({
						productId,
						productSku,
						nowPrice: NowPrice,
						memberPrice: MemberPrice,
						annualMembershipFee: AnnualMembershipFee,
						financePromotionCodes: financePromotions.map(
							(p) => p.PromotionCode
						),
						isInStock: State !== 'OutOfStock',
					})
				);
			}}
			data-tag-name="non-member-display-monthly-installments-button"
			data-tag-finance-type={`${financeType}`}
			data-tag-product={productTitle}
			data-testid="non-member-lister-finance-instalments">
			{financeTextFactory()}
			<span className="ico ico-chevron-right ico-lg"></span>
		</div>
	);
};

export default FinanceWithChevron;
